module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 007.287b70f4.jpg";